import CreateDamage from "./CreateDamage";
import DeleteConfirmation from "./DeleteConfirmation";
import DeleteFormConfirmation from "./DeleteFormConfirmation";
import AssociationConfirmation from "./AssociationConfirmation";
import CreateEvent from "./CreateEvent";
import EditDamage from "./EditDamage";

const Dialogs  = {
    CreateDamage,
    EditDamage,
    DeleteConfirmation,
    DeleteFormConfirmation,
    AssociationConfirmation,
    CreateEvent
}

export default Dialogs;